import { KnockOperator, KnockOrderByOptions } from './Knock/KnockTypes'

export enum PinnedStatus {
  Left = 'LEFT',
  Right = 'RIGHT',
  Center = 'CENTER'
}

export enum SpecialIndex {
  First = 'FIRST',
  Last = 'LAST'
}

export enum RowHeight {
  Small = 'SMALL',
  Medium = 'Medium',
  Large = 'Large'
}

export interface IFilterProps<T> {
  name: string
  filter: T
  filterOperator: string
  onChange: (value: T) => void
}

export interface IColumn {
  key: string
  name: string // name is mapped from the translations
  width: number
  index: number | SpecialIndex
  pinned: PinnedStatus

  filterComponent?: React.ComponentType<IFilterProps<any>>
  filter?: string
  filterOperator?: KnockOperator

  sortOrder?: KnockOrderByOptions
  sortIndex?: number

  visible?: boolean
  static?: boolean
  localOnly?: boolean
}

export interface IExtendedColumn extends IColumn {
  action?: (row: IBodyRow, cell: IBodyCell) => void
}

export interface IBodyRow<D = any, C = any> {
  id: number
  data: D
  cols: Array<IBodyCell<C>>
}

export interface IBodyCell<C = any> {
  key: string
  content: C
  visible?: boolean
  cellComponent: React.ComponentType<{ content: string }>
}

type FilterChangeValue = Pick<IColumn, 'filter' | 'filterOperator' | 'sortOrder' | 'sortIndex'>

export interface onFilterChangeOption {
  skipLocalStorage?: boolean // when true, do not store anything in the local storage
  skipApiStorage?: boolean // when true, do not execute api call to store in db
}

export type onDoubleClick = (row: IBodyRow) => void
export type onHoverPopup = (row: IBodyRow) => JSX.Element
export type onColumnMove = (source: IColumn, target: IColumn | number, pinnedStatus?: PinnedStatus) => void
export type onColumnResizeCommit = (key: string, width: number) => void
export type onColumnResize = (key: string, width: number) => void
export type onFilterChange = (columns: IColumn[], options?: onFilterChangeOption) => void
export type onFilterChangeWrapped = (column: IColumn, value: FilterChangeValue) => void
export type onRowClassName = (row: IBodyRow) => string | undefined

export type onRowHover = (index: number | null) => void
